import React from "react";
import { Input } from "../../components/ui/input";
import GoogleLoginButton from "../../components/VibrantSolComponents/GoogleLoginButton";

function SignUpModal({ onClose, onSignIn }) {
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
      <div className="bg-white rounded-xl shadow-2xl p-8 relative w-full max-w-md">
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <h2 className="text-3xl font-bold mb-2 text-center secdory-font">
          Sign Up
        </h2>
        <p className="text-center text-gray-600 mb-6">
          Create your account by filling the form below
        </p>
        <form>
          <Input
            type="text"
            placeholder="Full Name"
            className="w-full mb-4 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
          />
          <Input
            type="email"
            placeholder="Your email"
            className="w-full mb-4 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
          />
          <Input
            type="password"
            placeholder="Password"
            className="w-full mb-2 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
          />
          <Input
            type="password"
            placeholder="Confirm Password"
            className="w-full mb-2 px-4 py-6 border border-gray-200 rounded-md focus:outline-none"
          />
          {/* Add any additional fields */}
          <button
            type="submit"
            className="w-full bg-primary text-white py-3 rounded-md font-semibold mb-4 hover:bg-gray-800 transition"
          >
            Sign Up
          </button>
        </form>
        <p className="text-center text-gray-600 mb-6">
          Already have an account?{" "}
          <span
            className="text-black font-semibold cursor-pointer"
            onClick={onSignIn}
          >
            Log in
          </span>
        </p>
        <div className="my-4 flex items-center">
          <div className="flex-grow border-t border-gray-200"></div>
          <span className="mx-3 text-gray-400">or Log-in with</span>
          <div className="flex-grow border-t border-gray-200"></div>
        </div>
        <div className="flex gap-4">
          <button className="flex-1 flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 font-medium hover:bg-gray-50">
            <svg class="w-5 h-5 mr-2" fill="#1877F2" viewBox="0 0 24 24">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"></path>
            </svg>
            Facebook
          </button>
          {/* <button className="flex-1 flex items-center justify-center gap-2 border border-gray-300 rounded-md py-2 font-medium hover:bg-gray-50">
            <svg class="w-5 h-5 mr-2" viewBox="0 0 24 24">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              ></path>
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              ></path>
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              ></path>
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              ></path>
            </svg>
            Google
          </button> */}
          <GoogleLoginButton />
        </div>
      </div>
    </div>
  );
}

export default SignUpModal;
